export const OPEN_CIC_ALERT_MODAL = 'OPEN_CIC_ALERT_MODAL';
export const CLOSE_CIC_ALERT_MODAL = 'CLOSE_CIC_ALERT_MODAL';

function openCicAlertModal(cicAlertId) {
  return {
    type: OPEN_CIC_ALERT_MODAL,
    isCicAlertModalShown: true,
    cicAlertId,
  };
}

function closeCicAlertModal(refreshPage) {
  return {
    type: CLOSE_CIC_ALERT_MODAL,
    isCicAlertModalShown: false,
    refreshPage
  };
}

export function showCicAlertModal(cicAlertId) {
  return (dispatch) => {
    dispatch(openCicAlertModal(cicAlertId));
  };
}

export function hideCicAlertModal(refreshPage) {
  return (dispatch) => {
    dispatch(closeCicAlertModal(refreshPage));
  };
}
